import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormHelperText, Grid2, IconButton, TextField, Typography, useTheme } from '@mui/material';
import { Formik } from 'formik';
import * as React from 'react';
import { IoMdClose } from 'react-icons/io';
import { useParams } from 'react-router-dom';
import { useUpdateDocumentStatusMutation } from 'store/slices/apis/documentsSlice';
import * as Yup from 'yup';

export default function ApproveDocument(props) {
    const { open, cancel, openNotification, rowData } = props;
    const theme = useTheme();
    const [updateWorkFlow, updateWorkFlowRes] = useUpdateDocumentStatusMutation();
    const [formData, setFormData] = React.useState({
        Comment: '',
        status: 'Approved',
        ids: rowData?.id
    })

    const handleSubmit = (values) => {
        const formdata = new FormData();
        Object.entries(values).forEach(([key, value]) => {
            formdata.append(key, value);
        });

        updateWorkFlow(formdata).unwrap();
    }


    React.useEffect(() => {
        if (updateWorkFlowRes?.isSuccess) {
            if (updateWorkFlowRes?.data?.status == 'success') {
                openNotification(updateWorkFlowRes?.data?.message, 'success')
            } else {
                openNotification(updateWorkFlowRes?.data?.message, 'error')
            }
            cancel();
        }
    }, [updateWorkFlowRes?.isSuccess]);

    const validationSchema = Yup.object({
        // Comment: Yup.string().required("Comment field is required."),
    });

    return (
        <React.Fragment>
            <Dialog
                open={open}
                // onClose={cancel}
                disableEnforceFocus
                disableRestoreFocus
                aria-labelledby="draggable-dialog-title"
                fullWidth={true}
                maxWidth={'sm'}
            >
                <DialogTitle sx={{ fontWeight: 500, fontSize: '20px', color: '#252525', paddingBottom: 0 }} id="draggable-dialog-title">
                    Approve
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={cancel}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <IoMdClose style={{ fontSize: '20px' }} />
                </IconButton>
                {/* <DialogContent>
                    <DialogContentText
                        sx={{ fontWeight: 400, fontSize: "16px", color: "#474747" }}
                    >
                        Are you sure you want to approve this document ? This
                        action is permanent.
                    </DialogContentText>
                </DialogContent> */}
                <DialogContent>
                    <DialogContentText sx={{ fontWeight: 400, fontSize: '16px', color: '#474747' }}>
                        <Typography variant='h6' sx={{ fontWeight: 400, mb: 1, fontSize: "16px", color: "#474747" }}>
                            Are you sure you want to approve this document? This
                            action is permanent.
                        </Typography>
                        <Formik
                            initialValues={formData}
                            validationSchema={validationSchema}
                            onSubmit={handleSubmit}
                            enableReinitialize
                        >
                            {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue, setTouched }) => (
                                <form onSubmit={handleSubmit}>

                                    <Grid2 size={12}>
                                        <TextField
                                            id="outlined-multiline-static"
                                            label="Comment (Optional)"
                                            name="Comment"
                                            multiline
                                            fullWidth
                                            rows={3}
                                            value={values?.Comment}
                                            onChange={handleChange}
                                            onBlur={() => setTouched({ ...touched, Comment: true })}
                                            slotProps={{ inputLabel: { shrink: true } }}
                                            variant="filled"
                                        />
                                        {/* {touched?.Comment && errors?.Comment &&
                                            <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${errors?.Comment}`}</FormHelperText>
                                        } */}
                                    </Grid2>

                                    <Grid2 size={12}>
                                        <DialogActions>
                                            {/* <Button variant="outlined" onClick={cancel} sx={{
                                                color: '#415385',
                                                fontSize: '16px',
                                                fontWeight: '500',
                                                textTransform: 'none',
                                                border: '1px solid #415385'
                                            }}>Cancel</Button> */}

                                            <Button
                                                type='submit'
                                                loading={updateWorkFlowRes?.isLoading}
                                                variant="contained"
                                                sx={{
                                                    backgroundColor: `${theme?.customSettings?.themeColor}`,
                                                    color: '#fff',
                                                    fontSize: '16px',
                                                    fontWeight: '500',
                                                    textTransform: 'none'
                                                }}
                                            >
                                                Approve
                                            </Button>
                                        </DialogActions>
                                    </Grid2>
                                </form>
                            )}
                        </Formik>
                    </DialogContentText>
                </DialogContent>
            </Dialog>
        </React.Fragment >
    );
}